//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import fixSafariOverflowScrolling from '../../utils/safari-fix'
import { Card, CardItem, MatchCard } from '../Common/Card'
import MatchEmpty from '../Common/MatchEmpty.vue'
import loadmoreView from '../Common/loadmoreView.vue'
import FilterOption from '../Common/FilterOption.vue'
import confirm from '../Common/Myconfirm.vue'

import { mapState, mapActions } from 'vuex'

export default {
  name: 'MatchList',
  components: {
    Card,
    CardItem,
    MatchCard,
    MatchEmpty,
    FilterOption,
    loadmoreView,
    confirm,
  },
  mounted() {
    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling')
    fixSafariOverflowScrolling(this, 'touch')
    window.addEventListener('scroll', this.handlescroll, true)
  },
  beforeRouteUpdate(to, from, next) {
    this.checkAppTabChange(to, from)
    next()
  },
  data() {
    return {
      matchlistdata: [],
      sportleagues: [],
      sportgird: [],
      placeholder: '没有赛事数据',
      offset: 0,
      showFilterOption: false,
      showsportFilterOption: false,
      selectedOption: {},
      selectedType: '',
      optionType: '',
      current: null,
      currentsportid: null,
      options: [],
      canloadmore: false,
      selected: {
        time: {},
        team: {},
        city: {},
        sport: {},
      },
      filter: {
        time: null,
        teamId: null,
        cityId: null,
      },
      showFilter: false,
      showmoreLoading: false,
      showWorldCup: true,
      isOversea: false,
      isCtcSell: false, // 是否C2C转票
      sportimages: [
        { id: '全部', value: '/static/images/icons/whole.png' },
        { id: '足球', value: '/static/images/icons/football.png' },
        { id: '篮球', value: '/static/images/icons/basket.png' },
        { id: '网球', value: '/static/images/icons/tennis.png' },
        { id: '冰球', value: '/static/images/icons/iceball.png' },
        { id: '高尔夫', value: '/static/images/icons/golf.png' },
        { id: '电竞', value: '/static/images/icons/electric.png' },
        { id: '赛车', value: '/static/images/icons/racing.png' },
        { id: '排球', value: '/static/images/icons/volleyball.png' },
        { id: '羽毛球', value: '/static/images/icons/badminton.png' },
        { id: '乒乓球', value: '/static/images/icons/tabletennis.png' },
        { id: '橄榄球', value: '/static/images/icons/rugby.png' },
        { id: '格斗', value: '/static/images/icons/combat.png' },
      ],
    }
  },
  computed: {
    ...mapState({
      allLeagues: ({ league }) => league.league,
      filterInfo: ({ league }) => league.filterInfo,
    }),
    leagues() {
      return this.allLeagues
    },
  },
  watch: {
    allLeagues() {
      this.initSportGird()
      // this.$refs.myConfirm.show('信息不全，请补充', {
      //   type: '2',
      //   cancelText: '取消', // 取消按钮的文字
      //   confirmText: '确认', // 确认按钮的文字
      //   data: '',
      // })
    },
  },
  methods: {
    ...mapActions(['fetchMatchList', 'fetchLeagueList', 'fetchFilterInfo']),
    isEmpty(data) {
      this.showmoreLoading = false
      if (data.matches.length === 0) {
        this.canloadmore = false
        this.placeholder = '没有赛事数据'
      }

      if (this.matchlistdata === null) {
        this.matchlistdata = []
      }
      for (let i = 0; i < data.matches.length; i += 1) {
        this.matchlistdata.push(data.matches[i])
      }
      this.canloadmore = true
    },
    loadmore(data) {
      this.showmoreLoading = false
      if (data.matches.length === 0) {
        this.canloadmore = false
        this.placeholder = '没有赛事数据'
      }
      if (this.matchlistdata === null) {
        this.matchlistdata = []
      }

      for (let i = 0; i < data.matches.length; i += 1) {
        this.matchlistdata.push(data.matches[i])
      }
    },
    getFilterInfo(leagueId) {
      return this.fetchFilterInfo(leagueId)
    },
    onFilterClose() {
      if (this.showsportFilterOption) {
        this.showsportFilterOption = false
      }
      if (this.showFilterOption) {
        this.showFilterOption = false
      }
    },
    handleFilterChanged() {
      this.matchlistdata = null
      this.showmoreLoading = true
      this.fetchMatchList({
        isAllowC2c: this.isCtcSell,
        isOversea: this.isOversea,
        sportId: this.currentsportid,
        leagueId: this.current,
        queryString: null,
        opts: this.filter,
        offset: 0,
      }).then((data) => {
        this.isEmpty(data)
      })
    },
    roadmore() {
      this.showmoreLoading = true
      this.fetchMatchList({
        isOversea: this.isOversea,
        isAllowC2c: this.isCtcSell,
        sportId: this.currentsportid,
        leagueId: this.current,
        queryString: null,
        opts: this.filter,
        offset: this.matchlistdata.length,
      }).then((data) => {
        this.loadmore(data)
      })
    },
    toggleFilterOption(opts, type) {
      if (this.showFilterOption && this.selectedType === type) {
        this.showFilterOption = false
        return
      }
      this.resetFilterOffset()
      this.options = opts
      this.showFilterOption = true
      this.selectedType = type
      if (this.selectedType === 'team') {
        this.selectedOption = this.selected.team
        this.optionType = 'multi'
      } else if (this.selectedType === 'city') {
        this.selectedOption = this.selected.city
        this.optionType = 'multi'
      } else if (this.selectedType === 'time') {
        this.optionType = 'single'
        this.selectedOption = this.selected.time
      } else if (this.selectedType === 'sport') {
        this.optionType = 'sport'
      }
    },
    togglesportFilterOption(opts, type) {
      if (this.showsportFilterOption && this.selectedType === type) {
        this.showsportFilterOption = false
        return
      }

      this.showFilterOption = false

      this.resetFilterOffset()
      this.options = opts
      this.showsportFilterOption = true
      this.selectedType = type
      this.optionType = 'sport'
    },
    handleOptionChanged(option, show) {
      this.showFilterOption = show
      this.showsportFilterOption = show
      this.selectedOption = option
      if (this.selectedType === 'team') {
        this.selected.team = option
        this.filter.teamId = option.id
      } else if (this.selectedType === 'city') {
        this.selected.city = option
        this.filter.cityId = option.id
      } else if (this.selectedType === 'time') {
        this.selected.time = option
        if (option.start) {
          this.filter.time = `${option.start}|${option.end}`
        } else {
          this.filter.time = ''
        }
      } else if (this.selectedType === 'sport') {
        this.selected.sport = option
        this.currentsportid = this.selected.sport.id
        this.showsportFilterOption = false
        this.current = null
        this.initleaguestab(this.selected.sport.id)
        this.$refs.sporttext.innerHTML = this.selected.sport.name
        this.$refs.sportimg.src = this.getSportImg(this.selected.sport.name)
      }
      this.rewriteUrl()
      this.handleFilterChanged()
    },
    switchTab(leagueId) {
      this.showmoreLoading = false
      if (+leagueId === 21) {
        this.showWorldCup = true
      } else {
        this.showWorldCup = false
      }
      this.isCtcSell = this.isOversea? false : this.isCtcSell;
      const replaceQuery = { isOversea: this.isOversea ? 'yes' : 'no' }
      if (leagueId) {
        replaceQuery.sportId = this.currentsportid
        replaceQuery.leagueId = leagueId
      }
      this.$router.replace({
        name: 'match-list',
        query: replaceQuery,
      })
      this.showFilterOption = false
      this.current = leagueId

      this.matchlistdata = null
      this.showmoreLoading = true
      this.fetchMatchList({
        sportId: this.currentsportid,
        isAllowC2c: this.isCtcSell,
        leagueId,
        isOversea: this.isOversea }).then((data) => {
          this.isEmpty(data)
        })
      this.selected = {
        time: {},
        team: {},
        city: {},
      }
      this.filter = {
        time: null,
        teamId: null,
        cityId: null,
      }
      const league = this.allLeagues.find(lg => lg.id == leagueId) // eslint-disable-line eqeqeq
      if (league) {
        this.showFilter = league.enableFilter
        if (this.showFilter) {
          this.getFilterInfo(leagueId)
        }
      }
    },
    reloadLeagues() {
      const param = { isOversea: this.isOversea }
      this.fetchLeagueList(param).then(() => {
        if (this.leagues.length) {
          const { leagueId, teamId, cityId, time } = this.$route.query
          if (teamId || cityId || time) {
            this.loadMatchListByFilterParams(leagueId, teamId, cityId, time)
          }
        }
      })
    },
    rewriteUrl() {
      const replaceQuery = { isOversea: this.isOversea ? 'yes' : 'no' }
      replaceQuery.leagueId = this.current
      replaceQuery.sportId = this.currentsportid
      const query = Object.assign({}, replaceQuery, this.filter)
      this.$router.replace({
        name: 'match-list',
        query,
      })
    },
    loadMatchListByFilterParams(leagueId, teamId, cityId, time) {
      if (+leagueId === 21) {
        this.showWorldCup = true
      } else {
        this.showWorldCup = false
      }
      this.showFilterOption = false
      this.current = leagueId

      this.selected = {
        time: {},
        team: {},
        city: {},
      }
      this.filter = {
        time,
        teamId,
        cityId,
      }

      this.handleFilterChanged()
      const league = this.allLeagues.find(lg => lg.id == leagueId) // eslint-disable-line eqeqeq
      if (league) {
        this.showFilter = league.enableFilter
        if (this.showFilter) {
          this.getFilterInfo(leagueId).then(({ teams, cities, dateLabels }) => {
            if (teamId && teams && teams.length) {
              const team = teams.find(ob => ob.id === +teamId)
              this.selected.team = team != null ? team : {}
            }
            if (cityId && cities && cities.length) {
              const city = cities.find(ob => ob.id === +cityId)
              this.selected.city = city != null ? city : {}
            }

            if (time && dateLabels && dateLabels.length) {
              const [start, end] = time.split('|')
              const dateLabel = dateLabels.find(ob => ob.start === start && ob.end === end)
              this.selected.time = dateLabel != null ? dateLabel : {}
            }
          })
        }
      }
    },
    resetFilterOffset() {
      const tab = document.querySelector('.match-list-wrapper .yoyo-tab')
      if (tab) {
        this.offset = tab.offsetHeight + 44
      }
    },
    checkAppTabChange(to, from) {
      if (to.query.isOversea !== from.query.isOversea) {
        this.parseQuery(to.query)
        this.showFilter = false
        this.reloadLeagues()
      }
    },
    parseQuery(query) {
      const { isOversea } = query
      this.isOversea = !(isOversea === 'no') // 默认国外
    },
    tabclick(id, event) {
      for (let i = 0; i < this.$refs.lineitem.length; i += 1) {
        this.$refs.lineitem[i].style.display = 'none'
        this.$refs.fontitem[i].style.color = '#000000'
        this.$refs.fontitem[i].style.fontWeight = 'normal'
      }
      event.currentTarget.childNodes[0].style.color = '#00C0C1'
      event.currentTarget.childNodes[0].style.fontWeight = '500'
      event.currentTarget.childNodes[3].style.display = 'block'
      this.switchTab(id)
    },
    initleaguestab(sportid) {
      const item2 = []
      this.sportleagues = []
      const obj0 = { id: null, value: '全部' }
      item2.push(obj0)
      for (let i = 0; i < this.leagues.length; i += 1) {
        if (sportid === null) {
          const obj = { id: this.leagues[i].id, value: this.leagues[i].name }
          item2.push(obj)
        } else if (this.leagues[i].sport.id === sportid) {
          const obj = { id: this.leagues[i].id, value: this.leagues[i].name }
          item2.push(obj)
        }
      }

      this.sportleagues = item2

      // 去重复
      const ids = {}
      this.sportleagues = this.sportleagues.filter((val, index) => {
        if (val.id in ids) {
          this.sportleagues[ids[val.id]].value = val.value
          return false
        }
        ids[val.id] = index
        return true
      })

      this.$nextTick(() => {
        this.$refs.lineitem[0].style.display = 'block'
        this.$refs.fontitem[0].style.color = '#00C0C1'
        this.$refs.fontitem[0].style.fontWeight = '500'
        for (let i = 1; i < this.$refs.lineitem.length; i += 1) {
          this.$refs.lineitem[i].style.display = 'none'
          this.$refs.fontitem[i].style.color = '#000000'
          this.$refs.fontitem[i].style.fontWeight = 'normal'
        }

        if (this.$route.query.leagueId === undefined) {
          this.switchTab(null)
        } else {
          for (let i = 0; i < this.sportleagues.length; i += 1) {
            if (Number(this.$route.query.leagueId) === Number(this.sportleagues[i].id)) {
              for (let j = 0; j < this.$refs.lineitem.length; j += 1) {
                this.$refs.lineitem[j].style.display = 'none'
                this.$refs.fontitem[j].style.color = '#000000'
                this.$refs.fontitem[j].style.fontWeight = 'normal'
              }

              this.$refs.tabhomeitemref[i].childNodes[0].style.color = '#00C0C1'
              this.$refs.tabhomeitemref[i].childNodes[0].style.fontWeight = '500'
              this.$refs.tabhomeitemref[i].childNodes[3].style.display = 'block'
              this.switchTab(this.$route.query.leagueId)
              break
            }
          }
        }
      })
    },
    initSportGird() {
      this.sportgird = []
      const obj0 = { id: null, name: '全部', img: this.sportimages[0].value }
      this.sportgird.push(obj0)
      for (let i = 0; i < this.leagues.length; i += 1) {
        for (let k = 0; k < this.sportimages.length; k += 1) {
          if (this.leagues[i].sport.name === this.sportimages[k].id) {
            this.sportgird.push({
              id: this.leagues[i].sport.id,
              name: this.leagues[i].sport.name,
              img: this.sportimages[k].value })
          }
        }
      }

      // 去重复
      const ids = {}
      this.sportgird = this.sportgird.filter((val, index) => {
        if (val.id in ids) {
          this.sportgird[ids[val.id]].value = val.value
          return false
        }
        ids[val.id] = index
        return true
      })
      this.showsportFilterOption = false


      let all = true
      for (let j = 0; j < this.sportgird.length; j += 1) {
        if (Number(this.$route.query.sportId) === Number(this.sportgird[j].id)) {
          this.$refs.sporttext.innerHTML = this.sportgird[j].name
          this.$refs.sportimg.src = this.getSportImg(this.sportgird[j].name)
          all = false
          this.initleaguestab(this.sportgird[j].id)
          this.currentsportid = this.sportgird[j].id
          this.current = this.$route.query.leagueId
          break
        }
      }
      if (all) {
        this.$refs.sporttext.innerHTML = this.sportgird[0].name
        this.$refs.sportimg.src = this.getSportImg(this.sportgird[0].name)
        this.initleaguestab(this.sportgird[0].id)
        this.currentsportid = this.sportgird[0].id
        this.current = null
      }
    },
    getSportImg(sportname) {
      for (let k = 0; k < this.sportimages.length; k += 1) {
        if (sportname === this.sportimages[k].id) {
          return this.sportimages[k].value
        }
      }
      return ''
    },
    handlescroll() {
      const el = document.getElementById('content-wrapper')
      const offsetHeight = el.offsetHeight
      const scrollTop = el.scrollTop
      const scrollHeight = el.scrollHeight
      if ((offsetHeight + scrollTop) - scrollHeight >= -1) {
        if (this.canloadmore) {
          this.roadmore()
        }
      }
    },
    toSellerMatchList() {
      this.isCtcSell = true;
    },
    backToMatchList() {
      this.isCtcSell = false;
      this.switchTab(null);
    }
  },
  created() {
    document.title = '购票'
    this.parseQuery(this.$route.query)
    this.reloadLeagues()
  },
}



// WEBPACK FOOTER //
// ./client/components/Match/MatchList.vue